import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";
import { emailBlockSchema, IEmailBlockSchema } from "./email-template";

export const savedEmailSectionSchema = z.object({
  _id: zExt.objectId(),
  name: z.string(),
  blocks: z.array(emailBlockSchema as IEmailBlockSchema),
  team: zExt.objectId(),
  createdAt: z.date().nullish(),
  updatedAt: z.date().nullish(),
  isActive: z.boolean().default(true),
});

export type SavedEmailSection = z.infer<typeof savedEmailSectionSchema>;
export interface ISavedEmailSection extends z.ZodType<SavedEmailSection> {}
